import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M12 13H18.5C19.1904 13 19.75 13.5596 19.75 14.25V19.541V21.6662C19.75 22.1282 19.1769 22.343 18.8732 21.9948L16.7328 19.541H12C11.3096 19.541 10.75 18.9813 10.75 18.291V14.25C10.75 13.5596 11.3096 13 12 13Z" vectorEffect="non-scaling-stroke" />
	</SVG>
);
